import { render } from "./PromotionServices.vue?vue&type=template&id=d7a348a4&scoped=true"
import script from "./PromotionServices.vue?vue&type=script&lang=js"
export * from "./PromotionServices.vue?vue&type=script&lang=js"

import "./PromotionServices.vue?vue&type=style&index=0&id=d7a348a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7a348a4"],['__file',"src/views/Home/components/PromotionServices.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d7a348a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d7a348a4', __exports__)) {
    console.log('reload')
    api.reload('d7a348a4', __exports__)
  }
  
  module.hot.accept("./PromotionServices.vue?vue&type=template&id=d7a348a4&scoped=true", () => {
    console.log('re-render')
    api.rerender('d7a348a4', render)
  })

}


export default __exports__